import { ROUTES } from '../lib/routes';
import { navigate } from '../router';
import { createLockedPanel } from '../components/ui/LockedPanel';
import { el } from '../utils/dom';

export function renderExistingInstallPage(root: HTMLElement): void {
  const wrap = el('div', {});

  wrap.append(
    el('div', { className: 'ev123-page-head ev123-page-head--sub' }, [
      el('div', { className: 'ev123-container' }, [
        el('h1', { className: 'ev123-page-head__title', text: '기설치 충전기 이력 조회' }),
        el('p', {
          className: 'ev123-page-head__lead',
          text: '운영 중 설비 이력·증설·교체 검토를 한곳에서 보는 기능은 준비 중입니다.',
        }),
      ]),
    ])
  );

  const container = el('div', { className: 'ev123-container ev123-stack' });

  container.appendChild(
    createLockedPanel('준비 중', [
      '해당 기능은 순차적으로 제공할 예정입니다.',
      '오픈 시 이 페이지에서 안내드리겠습니다.',
    ])
  );

  const searchCard = el('div', { className: 'ev123-card ev123-card--future ev123-locked' });
  searchCard.append(
    el('h2', { className: 'ev123-card__title ev123-card__title--sub', text: '시설 검색' }),
    el('p', {
      className: 'ev123-card__desc ev123-card__desc--sub',
      text: '시설명·주소 등으로 검색할 수 있도록 구성할 예정입니다.',
    }),
    el('div', { className: 'ev123-field' }, [
      el('input', {
        className: 'ev123-input',
        type: 'text',
        placeholder: '준비 중',
        disabled: 'true',
      }),
    ]),
    el('button', {
      type: 'button',
      className: 'ev123-btn ev123-btn--muted',
      text: '준비 중',
      disabled: 'true',
    })
  );
  container.appendChild(searchCard);

  const resultCard = el('div', { className: 'ev123-card ev123-card--future' });
  resultCard.append(
    el('h2', { className: 'ev123-card__title ev123-card__title--sub', text: '조회 결과' }),
    el('p', {
      className: 'ev123-card__desc ev123-card__desc--sub',
      text: '이력·증설·교체 검토 영역을 나누어 표시할 예정입니다.',
    })
  );

  const grid = el('div', { className: 'ev123-grid ev123-grid--2' });
  grid.append(
    placeholderBlock('설치 이력', '설치 시기·용량·운영 주체'),
    placeholderBlock('증설·교체', '전력·면수·정책 요약')
  );
  resultCard.appendChild(grid);

  const empty = el('div', { className: 'ev123-empty ev123-empty--sub' });
  empty.append(
    el('div', { className: 'ev123-empty__title', text: '조회 결과 없음' }),
    el('p', { className: 'ev123-card__desc', text: '기능 오픈 후 이용 가능합니다.' })
  );
  resultCard.appendChild(empty);
  container.appendChild(resultCard);

  const foot = el('p', { className: 'ev123-page-footnote' });
  const link = el('button', { type: 'button', className: 'ev123-link-btn', text: '상담 신청' }) as HTMLButtonElement;
  link.addEventListener('click', () => navigate(ROUTES.consult));
  foot.append(document.createTextNode('긴급 문의는 '), link, document.createTextNode('을 이용해 주세요.'));
  container.appendChild(foot);

  wrap.appendChild(container);
  root.appendChild(wrap);
}

function placeholderBlock(title: string, hint: string): HTMLElement {
  const b = el('div', { className: 'ev123-panel ev123-panel--sub' });
  b.append(
    el('div', { className: 'ev123-panel__title', text: title }),
    el('p', { className: 'ev123-card__desc', text: hint })
  );
  const p = b.querySelector('p') as HTMLElement;
  if (p) p.style.margin = '0';
  return b;
}
